import { Location } from '../../../integrated-client/models/Location'

export interface ILocationEditorData {
  locationData?: Location
  validation?: any
}
export class LocationEditorData implements ILocationEditorData {

  locationData?: Location
  validation?: any
}